import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { DisplayCard } from 'components/DisplayCards/DisplayCard'
import { NavBar } from 'components/NavBar/NavBar'
import { useNavigate } from 'react-router-dom'
import { Flex, MainHeadline, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'

export const Safety = () => {

    const navigate = useNavigate()

    return <>
        <NavBar />
        <PageWrapper>
            <MainHeadline>Safety</MainHeadline>
            <Flex gap='1rem' style={{ margin: '2rem 0' }} >
                <DisplayCard value={100} label='HELD ZONES' borderColor='#ff9900' />
                <DisplayCard value={100} label='ACTIVE PERMITS' borderColor='#ff9900' />
                <DisplayCard value={100} label='SUSPENDED PERMITS' borderColor='#ff9900' />
                <DisplayCard value={100} label='DRAFT + ISSUES' borderColor='#ff9900' />
            </Flex>
            <Flex gap='1rem' >
                <Container>
                    <ContainerHeader>
                        <Flex width='100%' between center >
                            <TitleText weight='bold' >Zone Statuses</TitleText>
                            <OtherText onClick={() => navigate('zone-tree')} style={{ color: '#ff9900', cursor: 'pointer', }}> Open tree </OtherText>
                        </Flex>
                    </ContainerHeader>
                    <ContainerContent>
                        <BodyText grey >Distribution across the 4-level hierarchy</BodyText>
                        <Flex column gap='1rem' style={{ padding: '1rem' }} >
                            <Flex width='100%' between >
                                <BodyText  >Operational</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >Held</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >Evacuated</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                        </Flex>
                    </ContainerContent>
                </Container>

                <Container>
                    <ContainerHeader>
                        <Flex width='100%' between center>
                            <TitleText weight='bold' >Permits</TitleText>
                            <OtherText onClick={() => navigate('permits')} style={{ color: '#ff9900', cursor: 'pointer', }}> View all </OtherText>
                        </Flex>
                    </ContainerHeader>
                    <ContainerContent>
                        <BodyText grey >Distribution by lifecycle status</BodyText>
                        <Flex column gap='1rem' style={{ padding: '1rem' }} >
                            <Flex width='100%' between >
                                <BodyText  >Draft</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >Issued</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >Active</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >Suspended</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >Closed</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >Revoked</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                        </Flex>
                    </ContainerContent>
                </Container>

                <Container>
                    <ContainerHeader>
                        <Flex width='100%' between center>
                            <TitleText weight='bold' >Incidents</TitleText>
                            <OtherText onClick={() => navigate('incidents')} style={{ color: '#ff9900', cursor: 'pointer', }}> View all </OtherText>
                        </Flex>
                    </ContainerHeader>
                    <ContainerContent>
                        <BodyText grey >Open events by severity (excludes CLOSED)</BodyText>
                        <Flex column gap='1rem' style={{ padding: '1rem' }} >
                            <Flex width='100%' between >
                                <BodyText  >L1 - Minor</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >L2 - Moderate</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >L3 - Serious</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >L4 - Fatal / Catastrophic</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                        </Flex>
                    </ContainerContent>
                </Container>

                <Container>
                    <ContainerHeader>
                        <Flex width='100%' between center>
                            <TitleText weight='bold' >Fatigue</TitleText>
                            <OtherText onClick={() => navigate('fatigue')} style={{ color: '#ff9900', cursor: 'pointer', }}> View all </OtherText>
                        </Flex>
                    </ContainerHeader>
                    <ContainerContent>
                        <BodyText grey >At-risk workers by fatigue index and 7-day hours.</BodyText>
                        <Flex column gap='1rem' style={{ padding: '1rem' }} >
                            <Flex width='100%' between >
                                <BodyText  >Low</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >Elevated</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >High</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                            <Flex width='100%' between >
                                <BodyText  >Critical</BodyText>
                                <BodyText weight='bold' >11</BodyText>
                            </Flex>
                        </Flex>
                    </ContainerContent>
                </Container>
            </Flex>
        </PageWrapper>
    </>
}